import { useEffect } from "react";
import { useNavigate } from "react-router";
import { authentication_url } from "../apiclients/apiurls";
import { getGlobalLocationList, loginUser } from "../apiclients/streamsapi_bridge.js";
import ServerHandler from "../ai-chat-buddy/api/ServerHandler.js";
import { ChatBotHelper } from "../ai-chat-buddy/features/chatbot/handlers/ChatBotHelper.ts";
import { useAdminContext } from "../components/adminstore/Admin-Context.jsx";
import TabIDConstant from "../apiclients/TabIDConstant.js";

const Login = ({ setToken }) => {
  console.log("LOgin :::::::::::::::::::::::::::");
  const navigate = useNavigate();
  // const { setCompanyName } = useAdminContext();
  const loginfromAuth = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const authkey = urlParams.get('authkey');
    const reqType = urlParams.get('streamRequestFor');
    const isStreamReq = urlParams.get('streamsAdminRequest');
    const dealerId = urlParams.get('dealerid');
    const redirect_sms = urlParams.get('redirect_sms');
    // const reqType = 2;
    // const isStreamReq = 1;
    // const routeRequest = 1;

    if (authkey) {
      console.log("Auth key with login request recieved  :" + authkey);
      let homeTabId = TabIDConstant.HOME_TAB;
      sendAuthKeyLoginRequest(authkey, reqType, isStreamReq, dealerId, redirect_sms);
    } else {
      window.location.href = authentication_url;
    }
  }

  const sendAuthKeyLoginRequest = async (authkey, reqType, isStreamReq, dealerId, redirect_sms) => {
    let reqInfo = {};
    console.log("sendAuthKeyLoginRequest : " + authkey);
    reqInfo = await loginUser(authkey, dealerId);
    let respInfo = await reqInfo.json();
    console.log(respInfo);
    if (reqInfo.status == 200) {
      try {
        setUserSession(respInfo, reqType, isStreamReq);

        if (reqType && isStreamReq) {
          if (parseInt(reqType) === 6) {
            navigate("/helppage");
          }
          if (parseInt(reqType) === 1 || parseInt(reqType) === 7) {
            let selMember = { agentid: respInfo.logined_user }
            // let selMember = { agentid: "upswjuuxa@pbxtesting" }
            const combinedData = {
              selMember,
            }
            navigate("/userGeneralsettings", {
              state: combinedData,
            });
          }
          if (parseInt(reqType) === 2) {
            let selMember = { agentid: respInfo.logined_user, siteid: reqInfo.siteid }
            // let selMember = { agentid: "upswjuuxa@pbxtesting" }
            const combinedData = {
              selMember,
            }
            navigate("/onlineDevices", {
              state: combinedData,
            });
          }
          
          if (parseInt(reqType) === 9) {
            let selMember = { agentid: respInfo.logined_user ,voiceMail:true}
            const combinedData = {
              selMember,
            }
            navigate("/userGeneralsettings", {
              state: combinedData,
            });
          }

        } else if (redirect_sms) {
          if (parseInt(redirect_sms) === 1) {
            navigate("/smslanding", {
              state: { tab: "tab1" },
            });
          } else {
            navigate("/smslanding", {
              state: { tab: "tab2" },
            });
          }

        }else {
          await getGlobalLocation();
          navigate("/home");
        }
      } catch (e) {
        //   setError("Invalid email or password");
        console.log("Error::::::::::::" + e);
      }
      /**
       * Clear chat history and send CSRF request
       * This is to ensure that the chat history is cleared when the user logs in
       */
      try {
        ChatBotHelper.getInstance().clearChatBotHistory();
        ServerHandler.sendCSRFRequest();
      } catch (error) { }

    } else {
      //Un authorized user ::::::::::::::
      console.log("un authorized user :::::::::::::::::::");
      window.location.href = authentication_url;
    }

  };

  function setUserSession(userInfo, reqType, isStreamReq) {
    if (reqType) {
      userInfo.reqType = reqType;
    }
    if (reqType && (parseInt(reqType) === 1 || parseInt(reqType) === 2 ||  parseInt(reqType) === 9) && isStreamReq) {
      if(parseInt(reqType) === 1) userInfo.isStreamsSettingReq = 1;
      userInfo.isStreamReq = parseInt(isStreamReq);
    }
    if (reqType && parseInt(reqType) === 7) {
      userInfo.routeRequest = 1;
    }
    // const companyName = userInfo.companyName ? userInfo.companyName : "";
    // setCompanyName(companyName);
    sessionStorage.setItem("admin_session", JSON.stringify(userInfo));
    sessionStorage.setItem("token", userInfo.token);
    sessionStorage.setItem("refreshtoken", userInfo.refreshtoken);
    if(userInfo.streams_productname){
      // For framing the title dynamically.
      document.title = `${userInfo.streams_productname} Admin`;
    }
  }

  async function fetchData() {
    let validSession = false;
    try {
      if (sessionStorage.getItem("admin_session") && JSON.parse(sessionStorage.getItem("admin_session")).sitename == localStorage.getItem("admin_user")) {
        validSession = true;
      }
    } catch (e) {
      console.log("errore ::::::::::::::: " + e);
    }
    if (validSession) {
      /**
       * Clear chat history and send CSRF request
       * This is to ensure that the chat history is cleared when the user logs in
       */
      try {
        ChatBotHelper.getInstance().clearChatBotHistory();
        ServerHandler.sendCSRFRequest();
      } catch (error) { }

      navigate("/home");
    } else {
      loginfromAuth();
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

};

export async function getGlobalLocation() {
  try {
    sessionStorage.setItem("current_link", "home");
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    // const loggedinUser = JSON.parse(adminSession).logined_user;
    let response;
    // if (loggedinUser.indexOf("@") === -1) {
    const extracondition = `?module_type=1`;
    response = await getGlobalLocationList(siteid, extracondition);
    // } else {
    //   response = await getGlobalLocationForUser(siteid, loggedinUser);
    // }

    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    let rawData = await response.json();
    console.log("Global location ::::::::: " + JSON.stringify(rawData));
    if (!rawData) {
      window.alert(`info with id  not found`);
      // navigate("/");
    }
    const globalLoc = rawData?.result ?? [];
    const transformedLocationsList = (globalLoc || []).map(locations => ({ text: locations.entity_name, value: locations.entity_id }));
    const initialSelectedLoc = globalLoc.length > 0 ?
      globalLoc.filter(item => item.selected).map(item => item.entity_id) :
      [];
    console.log("global location data :::: " + JSON.stringify(transformedLocationsList));
    console.log("global location selected :::: " + JSON.stringify(initialSelectedLoc));
    sessionStorage.setItem("global_location_changed", true);
    sessionStorage.setItem("global_location", JSON.stringify(transformedLocationsList));
    sessionStorage.setItem("global_select_location", JSON.stringify(initialSelectedLoc));
  } catch (error) {

  }
}

export function isFiveNineAccount() {
  try {
    const sessionData = JSON.parse(sessionStorage.getItem("admin_session") || "{}");
    return sessionData?.isFive9Account === true && sessionData?.five9AccType === 1;
  } catch (e) {
    console.error("Failed to parse session data:", e);
    return false;
  }
}

export default Login;
